import { historyEntries, panelModes } from "@/mocks/panelContent";
import { PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

export default function HistorySection() {
  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <PanelCard
        title="Histórico de alterações"
        description="Toda alteração da Vellora registra campo, valor anterior, novo valor, data, horário e responsável."
        action={<PanelBadge tone="primary">{historyEntries.length} registros</PanelBadge>}
      >
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] border-collapse text-sm">
            <thead>
              <tr className="border-b border-background-300 text-left text-xs uppercase tracking-[0.12em] text-foreground-500">
                <th className="py-2 pr-4 font-medium">Campo alterado</th>
                <th className="py-2 pr-4 font-medium">Valor anterior</th>
                <th className="py-2 pr-4 font-medium">Novo valor</th>
                <th className="py-2 pr-4 font-medium">Data</th>
                <th className="py-2 pr-4 font-medium">Hora</th>
                <th className="py-2 font-medium">Responsável</th>
              </tr>
            </thead>
            <tbody>
              {historyEntries.map((entry) => (
                <tr key={entry.id} className="border-b border-background-200 last:border-0 align-top">
                  <td className="py-3 pr-4 text-foreground-800">{entry.field}</td>
                  <td className="py-3 pr-4 text-foreground-500">{entry.previous}</td>
                  <td className="py-3 pr-4 text-foreground-800">{entry.next}</td>
                  <td className="py-3 pr-4 text-foreground-600">{entry.date}</td>
                  <td className="py-3 pr-4 text-foreground-600">{entry.time}</td>
                  <td className="py-3 text-foreground-600">{entry.author}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {[
            "Salvar rascunho",
            "Visualizar antes de publicar",
            "Publicar alterações",
            "Cancelar",
            "Restaurar versão anterior",
          ].map((action) => (
            <span
              key={action}
              className="inline-flex cursor-not-allowed items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 text-xs text-foreground-400"
            >
              <i className="ri-lock-line text-sm" />
              {action}
            </span>
          ))}
        </div>
        <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
          Exclusões e arquivamentos sempre pedem confirmação. Credenciais, clientes reais, pedidos
          reais e dados pessoais nunca são expostos no modo público.
        </p>
      </PanelCard>
    </div>
  );
}